/**
 * InventoryImage.jsx
 * Created by Tim on 12/20/17.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { find } from 'lodash';
import axios from 'axios';

import ImageUnavailable from './ImageUnavailable';
import FauxImage from './FauxImage';

const propTypes = {
    type: PropTypes.string,
    id: PropTypes.string,
    hasFauxImageRatio: PropTypes.string
};

const defaultProps = {
    hasFauxImageRatio: ''
};

const imageUnavailable = (
    <div className="rec-inventory-image-wrap">
        <ImageUnavailable />
    </div>
);


export default class InventoryImage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            image: imageUnavailable
        };
    }

    componentDidMount() {
        const { type, id } = this.props;

        if (type && id) {
            this.loadMedia(type, id);
        }
    }

    componentDidUpdate(prevProps) {
        const { id, type } = this.props;

        if (id && prevProps.id !== id ||
            type && prevProps.type !== type) {
            this.loadMedia(type, id);
        }
    }

    loadMedia(type, id) {
        axios.get(`/api/media/public/${type}/${id}`, {})
            .then((res) => {
                if (res && !res.data.err) {
                    if (res.data.result) {
                        const photos = res.data.result;

                        // Set the preview photo, if it exists
                        let previewPhoto = find(photos, { is_preview: true });
                        if (previewPhoto === undefined) {
                            previewPhoto = null;
                        }

                        let image = null;
                        if (!previewPhoto && photos.length > 0) {
                            previewPhoto = photos[0];
                        }
                        // If an aspect ratio is set for the FauxImage and the inventory has a preview photo then use FauxImage to display the photo.
                        if (this.props.hasFauxImageRatio && previewPhoto) {
                            image = (
                                <div className="rec-flex-card-image-wrap">
                                    <FauxImage
                                        aspectRatio={this.props.hasFauxImageRatio}
                                        src={previewPhoto.url}
                                        altText={previewPhoto.title} />
                                </div>
                            );
                        }
                        else if (previewPhoto) {
                            image = (
                                <div className="rec-flex-card-image-wrap">
                                    <img
                                        src={previewPhoto.url}
                                        alt={previewPhoto.title}
                                        aria-label={previewPhoto.title} />
                                </div>
                            );
                        }
                        else {
                            image = imageUnavailable;
                        }

                        this.setState({ image });
                    }
                    else {
                        this.setState({
                            image: imageUnavailable
                        });
                    }
                }
                else {
                    this.setState({
                        image: imageUnavailable
                    });
                }
            })
            .catch(() => {
                this.setState({
                    image: imageUnavailable
                });
            });
    }

    render() {
        return this.state.image;
    }
}

InventoryImage.propTypes = propTypes;
InventoryImage.defaultProps = defaultProps;
